import { C } from '../theme/palette';
import { FS } from '../theme/typo';
import { useEnLigne } from './useEnLigne';

/**
 * Bandeau affiché tant que l'appareil est hors ligne.
 *
 * <p>Les écrans restent utilisables ; ce qui est saisi part au retour du
 * réseau (`useSyncedCollection` réécoute l'événement `online`). Sans ce
 * bandeau, une liste vide ou un enregistrement qui n'aboutit pas n'avait pas
 * d'explication.
 *
 * @param {object} props propriétés du composant
 * @param {boolean} [props.enLigne] état forcé (tests) ; sinon celui du navigateur
 * @returns {JSX.Element|null} le bandeau
 */
export function BandeauHorsLigne({ enLigne }) {
  const reseau = useEnLigne();
  const actif = enLigne === undefined ? reseau : enLigne;
  if (actif) return null;
  return (
    <div
      className="no-print"
      role="status"
      aria-live="polite"
      style={{
        background: C.amber,
        color: '#fff',
        padding: '8px 12px',
        fontSize: FS.sm,
        fontWeight: 700,
        textAlign: 'center',
        lineHeight: 1.4,
      }}
    >
      📡 Tu es hors ligne — les modifications seront envoyées au retour du réseau.
    </div>
  );
}
